import { ApiSuccessResponse } from "../../@types";
import { apiSlice } from "../../app/api/apiSlice";
import { CompanySearchResponse, CompanyStats } from "./@types";

export const companyApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCompanies: builder.mutation<
      ApiSuccessResponse<CompanySearchResponse>,
      Record<string, any>
    >({
      query: (data) => ({
        url: "/company/company/search",
        method: "POST",
        body: { ...data },
      }),
    }),
    getCompanyStats: builder.query<ApiSuccessResponse<CompanyStats>, void>({
      query: () => ({
        url: "/company/companystat",
        method: "GET",
      }),
    }),
    registerCompany: builder.mutation<
      ApiSuccessResponse<any>,
      Record<string, any>
    >({
      query: (data) => ({
        url: "/users/self-register",
        method: "POST",
        body: { ...data },
      }),
    }),
    verifyOtp: builder.mutation<ApiSuccessResponse<any>, Record<string, any>>({
      query: (data) => ({
        url: "/otp/verify-otp",
        method: "POST",
        body: { ...data },
      }),
    }),
    resendOtp: builder.mutation<ApiSuccessResponse<any>, Record<string, any>>({
      query: (data) => ({
        url: "/otp/get-otp",
        method: "POST",
        body: { ...data },
      }),
    }),
  }),
});

export const {
  useGetCompaniesMutation,
  useGetCompanyStatsQuery,
  useRegisterCompanyMutation,
  useVerifyOtpMutation,
  useResendOtpMutation,
} = companyApiSlice;
